<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar
      :base="base"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
    />
    <qualify-sidebar
      :form="select_request"
      :isSidebarActive="promptQualifySidebar"
      :customers="customers"
      :categories_requests="categories_requests"
      :sub_categories_requests="sub_categories_requests"
      :priorities="priorities"
      :commerciaux="commerciaux"
      :qualify-call-back="qualifyCallBack"
      :get-sub-categories="getSubCategories"
      @closeSidebar="toggleQualifySidebar"
    />
    <FilterList
      :isPromptActive="filterPrompt"
      @closePrompt="toggleFilterPrompt"
      :customers="customers"
      :priorities="priorities"
      :categories="categories_requests"
      :callBackFilter="callBackFilter"
    />

    <vs-table ref="table" :max-items="itemsPerPage" :data="requests">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div
            v-if="profile != '1' && profile != '6' && profile != '2'"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Nouvelle demande</span>
          </div>
          <div
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
            @click="filterPrompt = true"
          >
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Filtrer</span>
          </div>
          <div
            @click="refresh()"
            class="
              btn-add-new
              p-3
              mb-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
        </div>
        <div class="con-input-search vs-table--search">
          <input
            v-model="stringSearch"
            @keypress.enter="findRequests()"
            type="text"
            class="input-search vs-table--search-input"
          />
          <i class="vs-icon notranslate icon-scale material-icons null"
            >search</i
          >
        </div>
      </div>

      <template slot="thead">
        <vs-th width="10%" sort-key="ref">N°</vs-th>
        <vs-th width="25%" sort-key="title">Demande</vs-th>
        <vs-th width="20%" sort-key="type">Type</vs-th>
        <vs-th width="20%" sort-key="status">Statut</vs-th>
        <vs-th width="5%" sort-key="priority">Priorité</vs-th>
        <vs-th width="10%" sort-key="user_assign">Assigné par</vs-th>
        <vs-th width="10%" sort-key="user_owner">Assigné à</vs-th>
        <vs-th width="5%" sort-key="group">Envoyé par</vs-th>
        <vs-th width="10%" sort-key="created_at">Date</vs-th>
        <vs-th width="10%">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.ref }}</vs-td>
            <vs-td>
              <ul>
                <li class="flex justify-between py-3 px-6">
                  <span class="flex items-center">
                    <vx-tooltip text="Requête créée par un commercial">
                      <span
                        v-if="
                          tr.request_created_by_commercial && profile == '4'
                        "
                        class="inline-block h-3 w-3 rounded-full mr-2 bg-danger"
                      />
                    </vx-tooltip>
                    {{ tr.title }}
                  </span>
                </li>
              </ul>
              <!-- <span class="">{{ tr.title }} </span> -->
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.type | title }}</p>
            </vs-td>

            <vs-td>
              <vs-chip>{{ tr.status | title }}</vs-chip>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getPriorityColor(tr.priority)"
                class="product-order-status"
                >{{ tr.priority | title }}</vs-chip
              >
            </vs-td>

            <vs-td>
              <p class="group">{{ tr.user_assign }}</p>
            </vs-td>

            <vs-td>
              <p class="group">{{ tr.user_owner }}</p>
            </vs-td>

            <vs-td>
              <p class="group">{{ tr.group }}</p>
            </vs-td>
            <vs-td>
              <p class="product-price">{{ (tr.date_reception || tr.created_at) | title }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <div @click="goToSingle(tr.id, tr.has_proved)" class="flex">
                  <feather-icon
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    class="mr-2"
                  />
                  Détails
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-pagination
      v-if="last_page && page"
      :total="last_page"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
var base_self;
var input_tempon = {
  id: null,
  name: "",
  // category: null,
  // order_status: "",
  // price: 0,
  files: [],
  img: null,
  contract: "",
  contract_id: "",
  priority_id: "",
  requests_type_id: "",
  requests_subtype_id: "",
  request_content: "",
  customer_id: "",
  commercial_id: "",
  urgency_id: "",
  impact_id: "",
};
import FilterList from "./filter/FilterListApprobation";
import DataViewSidebar from "./components/DataViewSidebar.vue";
import qualifySidebar from "./components/qualifySidebar.vue";

export default {
  components: {
    DataViewSidebar,
    FilterList,
    qualifySidebar,
  },
  data() {
    return {
      filterPrompt: false,
      profile: "",
      stringSearch: "",
      last_page: 1,
      page: localStorage.getItem('page') ? parseInt(localStorage.getItem('page')) : 1,
      dispatcher: false,
      customers_contracts: [],
      sub_categories_requests: [],

      priorities: [],
      categories_requests: [],
      customers: [],

      input: JSON.parse(JSON.stringify(input_tempon)),
      input_second: JSON.parse(JSON.stringify(input_tempon)),
      selected: [],
      requestDatas: [],
      // requests: [],
      itemsPerPage: 50,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: "",
      commerciaux: [],
      select_request: {
        id: "",
        customer_id: "",
        title: "",
        type_request_id: "",
        subtype_request_id: "",
        priority_id: "",
        request_content: "",
      },
      promptQualifySidebar: false,
      urgencies: [],
      impacts: [],
    };
  },
  watch: {
    page(value) {
      if (base_self.stringSearch) {
        base_self.findRequests();
      } else {
        localStorage.setItem('page', value);
        base_self.getRequests(value, base_self.stringSearch);
      }
    },
    input: {
      handler(val) {
        base_self.watch_input_ajout_handler(val);
      },
      deep: true,
    },
  },
  computed: {
    isAdmin() {
      return this.$store.state.AppActiveUser.userRole === "admin";
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    requests() {
      return base_self.requestDatas;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.requests.length;
    },
    base() {
      return base_self;
    },
    input_tempon() {
      return input_tempon;
    },
  },
  methods: {
    getRequestDetails(id) {
      this.$vs.loading();
      this.$http
        .get("/requests/detail/information/" + id)
        .then((response) => {
          // this.$vs.loading.close();
          if (response.data) {
            this.select_request.id = response.data.id;
            this.select_request.customer_id = response.data.customer.id;
            this.select_request.title = response.data.title;
            this.select_request.type_request_id =
              response.data.requests_type_id;
            this.select_request.subtype_request_id =
              response.data.requests_subtype_id;
            this.select_request.priority_id = response.data.priority_id;
            this.select_request.request_content = response.data.content;
            this.select_request.commercial_id = response.data.commercial_id;
            this.getSub_categories_requests(response.data.requests_type_id);
            this.$vs.loading.close();
            console.log(this.select_request);
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
    toggleQualifySidebar(val = false) {
      console.log(val);
      this.promptQualifySidebar = val;
    },
    qualifyCallBack() {
      this.refresh();
    },
    getSubCategories(requests_type_id) {
      this.getSub_categories_requests(requests_type_id);
    },
    refresh() {
      base_self.stringSearch = {};
      base_self.page = 1;
      base_self.getRequests(base_self.page, base_self.stringSearch);
    },
    toggleFilterPrompt(val = false) {
      this.filterPrompt = val;
    },
    watch_input_ajout_handler(val) {
      if (
        val.customer_id &&
        val.customer_id !== base_self.input_second.customer_id
      ) {
        base_self.getCustomers_contracts(val.customer_id);
      }

      if (
        val.requests_type_id &&
        val.requests_type_id !== base_self.input_second.requests_type_id
      ) {
        base_self.getSub_categories_requests(val.requests_type_id);
      }

      if (
        val.contract_id &&
        val.contract_id !== base_self.input_second.contract_id
      ) {
        var length = base_self.customers_contracts.length;

        for (let iuoy = 0; iuoy < length; iuoy++) {
          var item = base_self.customers_contracts[iuoy];
          if (val.contract_id === item.id) {
            base_self.input.contract = item.code_contract;
          }
        }
      } else if (
        !val.contract_id &&
        val.contract_id !== base_self.input_second.contract_id
      ) {
        if (base_self.customers_contracts.length) {
          base_self.input.contract_id = base_self.customers_contracts[0].id;
          base_self.input.contract =
            base_self.customers_contracts[0].code_contract;
        }
      }

      // if (
      //   val.priority_id &&
      //   val.priority_id !== base_self.input_second.priority_id
      // ) {
      //   base_self.getUrgenciesByPriority(val.priority_id);
      // }

      // if (
      //   val.urgency_id &&
      //   val.urgency_id !== base_self.input_second.urgency_id
      // ) {
      //   base_self.getImpactsByUrgence(val.priority_id, val.urgency_id);
      // }

      base_self.input_second = JSON.parse(JSON.stringify(base_self.input));
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    getPriorityColor(status) {
      status = status.toLowerCase();
      if (status == "normale") return "primary";
      if (status == "basse") return "success";
      if (status == "haute") return "danger";
      return "primary";
    },
    getProgressionColor(num) {
      if (num > 90) return "success";
      if (num > 70) return "primary";
      if (num >= 50) return "warning";
      if (num < 50) return "danger";
      return "primary";
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    goToSingle(id, el) {
      let t = el ? 1 : 2;
      this.$router.push("/requests/" + id + "/detail/" + t);
    },
    async getRequests(page, stringSearch) {
      if (localStorage.getItem('page') && localStorage.getItem('page') == undefined) {
        base_self.page = localStorage.getItem('page');
      }
      base_self.$vs.loading();
      let response = await base_self.$store.state
        .requests_not_approved({}, { page, stringSearch })
        .catch((error) => {
          console.log("error: ", error);
        });
      base_self.last_page = response.data.last_page;
      base_self.requestDatas = response.data.data;
      base_self.$vs.loading.close();
    },
    async findRequests() {
      if (base_self.stringSearch) {
        base_self.$vs.loading();
        let params = {
          page: base_self.page,
          search: base_self.stringSearch,
          type: "not-approved",
        };
        let response = await base_self.$store.state
          .findRequests(params)
          .catch((error) => {
            console.log("error: ", error);
          });
        base_self.last_page = response.data.last_page;
        base_self.requestDatas = response.data.data;
        base_self.$vs.loading.close();
      } else {
        base_self.getRequests(base_self.page, base_self.stringSearch);
      }
    },
    async getPriorities() {
      let response = await base_self.$store.state
        .priorities({})
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.priorities = response.data;
    },
    async getCategories_requests() {
      let response = await base_self.$store.state
        .categories_requests({}, { paginate: 0 })
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.categories_requests = response.data;
    },
    async getSub_categories_requests(id) {
      let response = await base_self.$store.state
        .sub_categories_requests({}, id)
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.sub_categories_requests = response.data;
    },
    async getUrgenciesByPriority(id) {
      this.$vs.loading();
      this.$http
        .get("/requests/service-now/urgencies-by-priority?priority_id=" + id)
        .then((response) => {
          let values = response.data;
          base_self.urgencies = values;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 5000,
            title: "Échec!",
            text: "Veuillez rééessayer ou contacter l'administrateur",
            color: "danger",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-x-circle",
          });
        });
    },
    async getImpactsByUrgence(priority_id, urgency_id) {
      this.$vs.loading();
      this.$http
        .get(
          "/requests/service-now/impacts-by-urgency?priority_id=" +
            priority_id +
            "&urgency_id=" +
            urgency_id
        )
        .then((response) => {
          let values = response.data;
          base_self.impacts = values;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            time: 5000,
            title: "Échec!",
            text: "Veuillez rééessayer ou contacter l'administrateur",
            color: "danger",
            iconPack: "feather",
            position: "top-right",
            icon: "icon-x-circle",
          });
        });
    },
    async getCustomers() {
      let response = await base_self.$store.state
        .customers({})
        .catch((error) => {
          console.log("error: ", error);
        });

      base_self.customers = response.data;
    },
    async getCustomers_contracts(id) {
      // let response = await base_self.$store.state
      //   .customers_contracts({}, id)
      //   .catch((error) => {
      //     console.log("error: ", error);
      //   });
      // base_self.customers_contracts = response.data;
    },
    callBackFilter(model, stringSearch) {
      base_self.stringSearch = stringSearch;
      base_self.last_page = model.data.last_page;
      base_self.requestDatas = model.data.data;
    },
    loadCommerciaux(page) {
      // this.$vs.loading();
      let url = "/users?profile=7&paginate=0";
      this.$http
        .get(url)
        .then((response) => {
          base_self.commerciaux = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        });
    },
  },
  created() {
    base_self = this;
    window.RequestsApp = this;
  },
  async mounted() {
    this.isMounted = true;
    this.dispatcher = window.GETCCMT.$store.state.is_dispatcher();
    this.profile = window.GETCCMT.$store.state.AppActiveUser.profile_id;
    if (localStorage.getItem('page') && localStorage.getItem('page') !== undefined) {
      this.page = parseInt(localStorage.getItem('page'));
    }
    base_self.getRequests(localStorage.getItem('page'), base_self.stringSearch);
    base_self.getPriorities();
    base_self.getCategories_requests();
    base_self.getCustomers();
    base_self.loadCommerciaux();

    if (
      base_self.$store.state.is_client() ||
      base_self.$store.state.is_mandataire()
    ) {
      input_tempon.customer_id =
        base_self.$store.state.AppActiveUser.customer_id;
      base_self.input.customer_id =
        base_self.$store.state.AppActiveUser.customer_id;
      await base_self.getCustomers_contracts(
        base_self.$store.state.AppActiveUser.customer_id
      );

      if (base_self.customers_contracts.length) {
        base_self.input.contract_id = base_self.customers_contracts[0].id;
        base_self.input.contract =
          base_self.customers_contracts[0].code_contract;
      }
    }
  },
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.5rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
